import { answerSubCategorySchema } from "@/schema/console/checking-assessments/AnswerSubCategory";
import { z } from "zod";

export const answerCategoryDetailSchema = z.object({
  id: z.number(),
  content: z.string(),
  is_checked: z.coerce.boolean(),
  answer_sub_categories: z.array(answerSubCategorySchema),
});

export type AnswerCategoryDetail = z.infer<typeof answerCategoryDetailSchema>;
